import { render, staticRenderFns } from "./TypeMap.vue?vue&type=template&id=1573b2ba&"
import script from "./TypeMap.vue?vue&type=script&lang=js&"
export * from "./TypeMap.vue?vue&type=script&lang=js&"
import style0 from "./TypeMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports